import { render, staticRenderFns } from "./ConfigurationChapters.vue?vue&type=template&id=213e2a69&scoped=true&"
import script from "./ConfigurationChapters.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationChapters.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationChapters.vue?vue&type=style&index=0&id=213e2a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e2a69",
  null
  
)

export default component.exports